import { useLocalization } from "@i18n";
import { AppBackground } from "@shared/components";

export function TenantLoadingState() {
  const { translate } = useLocalization();

  return (
    <AppBackground className="min-h-screen flex items-center justify-center p-4">
      <div className="max-w-md w-full surface-primary p-6">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-primary/10 mb-4">
            <svg
              className="h-6 w-6 text-primary animate-spin"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          </div>

          <h2 className="text-heading-xl text-foreground mb-2">
            {translate("auth.loadingOrganizations")}
          </h2>
        </div>
      </div>
    </AppBackground>
  );
}

export default TenantLoadingState;
